import slugify from "slugify"
import React from "react"
import L10n from "../../../lib/carrot-l10n"
import { useSelector } from "react-redux"
import { getCurrentCategorySlug } from "reducers/library"
import { getCurrentCategory, getLibraryCategories } from "derivedSelectors/librarySelectors"
import { AccordionNavigation } from "../atoms/AccordionNavigation"
import { LeftStickySidebar } from "../atoms/Layouts"
import { RoundedRectangle } from "../atoms/roundedrectangle/RoundedRectangle"
import { RRNavLink } from "../atoms/roundedrectangle/RRNavLink"
import { RRHeaderWithHR } from "../atoms/roundedrectangle/RRHeaderWithHR"
import { getIsLathamAndWatkinsMember } from "derivedSelectors"
import { ContentfulConditionalGate } from "../../../lib/contentful/components/ContentfulConditionGate"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

export const CategoryLinks = ({ margin, noWrap }) => {
  const { categories, currentCategorySlug } = useSelector((state) => ({
    categories: getLibraryCategories(state),
    currentCategorySlug: getCurrentCategorySlug(state)
  }))

  const maxColumns = 3
  const numberOfFillerDivs = (maxColumns - (categories.length % maxColumns)) % maxColumns

  return (
    <>
      {categories.map((category) => {
        const categoryTitle = category.fields.title
        const categorySlug = slugify(categoryTitle)

        return (
          <>
            <ContentfulConditionalGate conditions={category.fields.conditions}>
              <div className={`${margin} w-100`} key={category.sys.id}>
                <RRNavLink to={`/read/${categorySlug}`} noWrap={noWrap} active={currentCategorySlug === categorySlug}>
                  {categoryTitle}
                </RRNavLink>
              </div>
            </ContentfulConditionalGate>
          </>
        )
      })}
      {[...new Array(numberOfFillerDivs)].map((x, i) => (
        <div key={i} className="w-33" />
      ))}
    </>
  )
}

const LibraryCollapsibleNavigation = () => {
  const currentCategory = useSelector(getCurrentCategory)

  return (
    <AccordionNavigation title={currentCategory && currentCategory.fields.title} subTitle={l`client.library.allTopics`}>
      <CategoryLinks noWrap={false} margin="mh25" />
    </AccordionNavigation>
  )
}

const LibraryTopNavigation = () => (
  <RoundedRectangle backgroundColor="mint-alternate">
    <RRHeaderWithHR>{l`client.topics`}</RRHeaderWithHR>
    <div className="flex flex-wrap nh25">
      <CategoryLinks noWrap={false} margin="mh25" />
    </div>
  </RoundedRectangle>
)

const LibraryStickySidebar = () => {
  const isLathamAndWatkinsMember = useSelector(getIsLathamAndWatkinsMember)
  return (
    <LeftStickySidebar
      links={<CategoryLinks noWrap={false} />}
      contentId={"library-content"}
      showLWInformational={isLathamAndWatkinsMember}
    />
  )
}

const LibraryNavigation = () => (
  <>
    <div className="dn db-l">
      <LibraryStickySidebar />
    </div>
    <div className="dn db-m dn-l">
      <LibraryTopNavigation />
    </div>
    <div className="db dn-ns">
      <LibraryCollapsibleNavigation />
    </div>
  </>
)
export default LibraryNavigation
